import { render, staticRenderFns } from "./OpportunityDetailsPage.vue?vue&type=template&id=157cc603&"
import script from "./OpportunityDetailsPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OpportunityDetailsPage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports